export default __webpack_public_path__ + "static/media/pro-elevate-gry-banner-3.fd213418.jpg";